// extracted by mini-css-extract-plugin
module.exports = {"ignoreContainer":"BirthdaysForm_ignoreContainer__SgsdC","ignoreInnerContainer":"BirthdaysForm_ignoreInnerContainer__JcWJt","ignoreNameLabel":"BirthdaysForm_ignoreNameLabel__ulflx"};